import { render } from "./WeChatCallbackView.vue?vue&type=template&id=62d0310f&scoped=true"
import script from "./WeChatCallbackView.vue?vue&type=script&lang=js"
export * from "./WeChatCallbackView.vue?vue&type=script&lang=js"

import "./WeChatCallbackView.vue?vue&type=style&index=0&id=62d0310f&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62d0310f"]])

export default __exports__